import client from '../lib/http-client';
import { buildQuery } from '../lib/helper';

const endpoint = '/displays';

export default {
	// Create
	create(params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const url = `${endpoint}`;
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	/**
	 * Create Bulk
	 *
	 * @param {Object[]} users Users
	 * @param {string} users.email Email
	 * @param {string} users.password Password
	 * @param {string} users.language Language
	 * @param {string} users.firstName First Name
	 * @param {string} users.gender Gender
	 * @param {*} cb Callback
	 * @param {*} errorCb Error Callback
	 */
	createBulk(users, cb, errorCb) {
		const url = `${endpoint}/createBulk`;
		const params = { users: JSON.stringify(users) };
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// update bulk
	removeRundown(displays, cb, errorCb) {
		const url = `${endpoint}/remove/rundown`;
		const params = { displays: JSON.stringify(displays) };
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.put(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},


	// Get
	get(id, params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/${id}?${query}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get by slug
	getBySlug(slug, cb, errorCb) {
		const url = `${endpoint}/slug/${slug}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Get List
	getList(params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const url = endpoint;
		client.get(url, { params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Bulk Delete
	bulkDelete(ids, cb, errorCb) {
		const params = {
			user_ids: JSON.stringify(ids),
			is_deleted: 1,
		};
		const url = `${endpoint}`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.delete(url, { data: params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	// Update
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Delete
	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Refresh rundown
	clearAccess(id, cb, errorCb) {
		const url = `${endpoint}/access/${id}`;
		client.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get
	getByUID(code, cb, errorCb) {
		const url = `${endpoint}/code/${code}`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},
};
